"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCalendarDisconnectResponse = exports.GoogleCalendarTokenResponse = exports.GoogleCalendarTokenRequest = exports.GoogleCalendarStatusResponse = exports.GoogleCalendarConsentUrlResponse = void 0;
const zod_1 = require("zod");
exports.GoogleCalendarConsentUrlResponse = zod_1.z.object({
    data: zod_1.z.object({
        consentUrl: zod_1.z.string(),
    }),
});
exports.GoogleCalendarStatusResponse = zod_1.z.object({
    data: zod_1.z.object({
        connected: zod_1.z.boolean(),
    }),
});
exports.GoogleCalendarTokenRequest = zod_1.z.object({
    url: zod_1.z.string(),
});
exports.GoogleCalendarTokenResponse = zod_1.z.object({
    data: zod_1.z.object({ success: zod_1.z.boolean() }),
});
exports.GoogleCalendarDisconnectResponse = zod_1.z.object({
    data: zod_1.z.object({ success: zod_1.z.boolean() }),
});
